import { render, staticRenderFns } from "./footer_layout.vue?vue&type=template&id=64cd32cb&scoped=true&"
import script from "./footer_layout.vue?vue&type=script&lang=ts&"
export * from "./footer_layout.vue?vue&type=script&lang=ts&"
import style0 from "./footer_layout.vue?vue&type=style&index=0&id=64cd32cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd32cb",
  null
  
)

export default component.exports